import * as React from 'react'

export default () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="5" fill="#26C36F" stroke="white" strokeWidth="2" />
  </svg>
)
